<template>
    <div>
        <h2>フランチャイズ店詳細ページ</h2>
        <v-simple-table class="elevation-1">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            フランチャイズ認証 / プレミア店認証
                        </th>
                        <th class="text-left">
                            有効 / 無効
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="text-left" v-for="item in elements" :key="item.name">
                        <td>{{ item.name }}</td>
                        <td>
                            <v-checkbox v-model="item.is_enable"
                                :label="`${item.is_enable.toString().replace('true', '有効').replace('false', '無効')}`"></v-checkbox>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
        <v-btn block color="primary" elevation="2" @click="updateInfo">変更する</v-btn>
    </div>
</template>


<script>
export default {
    data() {
        return {
            elements: [
                {
                    name: 'フランチャイズ認証',
                    is_enable: false,
                },
                {
                    name: 'プレミア店認証',
                    is_enable: false,
                },
            ],
            store_info: {},
        }
    },
    methods: {
        updateInfo() {
            this.axios
            .patch(`${process.env.VUE_APP_API_ORIGIN}/account/update`, {
                is_franchise: this.elements[0].is_enable,
                is_certification: this.elements[1].is_enable
            }, {
                params: { store_id: this.$route.params.store_id }
            })
            .then(res => {
                this.$router.push({ name: 'MainViewStores' })
            })
        },
    },
    mounted: function () {
        this.axios
        .get(`${process.env.VUE_APP_API_ORIGIN}/account/info`, {
            params: { store_id: this.$route.params.store_id }
        })
        .then(res => {
            this.store_info = res.data
            this.elements[0].is_enable = this.store_info.is_franchise
            this.elements[1].is_enable = this.store_info.is_certification
        })
    }
}
</script>
